import { Paper } from '@mui/material';
import { compose } from "@reduxjs/toolkit";
import { useEffect, useState } from 'react';
import { connect } from "react-redux";
import { useParams } from 'react-router-dom';
import { withRouter } from "../../components/withRouter";
import endpoint from '../../config/endpoints';
import { noInternetMsg } from "../../config/messageconstant";
import { showLoador, showNotification } from "../Landing/Landing.slice";
import { apiGet } from '../../utils/api_service';
import DynamicFormWithoutSave from '../../components/dynamicscreens/DynamicFormWithoutSave';
import cardViewStyles from "../../Styles/carryforwardAndEncashed";


const EncashedLeaveView = ({
    showLoador,
    showNotification,
}) => {

    const [salesTeamData, setSalesTeamData] = useState([]);
    const { id } = useParams();

    useEffect(() => {
        const fetchData = async () => {
            if (navigator.onLine) {
                if (id) {
                    showLoador({ loador: true });
                    await apiGet({
                        url: endpoint.encashedLeaveHeader
                            + "/by-sales-team?salesTeamId=" + id,
                    }).then(({ data, success }) => {
                        if (!success) {
                        } else {
                            let dataList = data.data.map((dataObj, index) => {
                                return {
                                    index: index + 1,
                                    id: dataObj.id !== null ? dataObj.id : "",
                                    salesTeamId: dataObj.salesTeamId !== null ? dataObj.salesTeamId : "",
                                    salesTeamName: dataObj.salesTeamName !== null ? dataObj.salesTeamName : "",
                                    designation: dataObj.designation !== null ? dataObj.designation : "",
                                    employeeCode: dataObj.employeeCode !== null ? dataObj.employeeCode : "",
                                    leaveYearId: dataObj.leaveYearId !== null ? dataObj.leaveYearId : "",
                                    leaveYearName: dataObj.leaveYearName !== null ? dataObj.leaveYearName : "",
                                    reportingManagerId: dataObj.reportingManagerId !== null ? dataObj.reportingManagerId : "",
                                    reportingManagerName: dataObj.reportingManagerName !== null ? dataObj.leaveYearId : "",
                                    reportingManagerType: dataObj.reportingManagerType !== null ? dataObj.reportingManagerType : "",
                                    insertDateTime: dataObj.insertDateTime !== null ? dataObj.insertDateTime : "",
                                    encashedLeaveDetails: dataObj.encashedLeaveDetails !== null ?
                                        dataObj.encashedLeaveDetails.map((detailsobj, index) => {
                                            return {
                                                index: index + 1,
                                                id: detailsobj.id !== null ? detailsobj.id : "",
                                                leaveTypeId: detailsobj.leaveTypeId !== null ? detailsobj.leaveTypeId : "",
                                                leaveTypeName: detailsobj.leaveTypeName !== null ? detailsobj.leaveTypeName : "",
                                                encashedLeaves: detailsobj.encashedLeaves !== null ? detailsobj.encashedLeaves : "",
                                                encashedLeaveHeaderId: detailsobj.encashedLeaveHeaderId !== null ? detailsobj.encashedLeaveHeaderId : "",
                                            }
                                        }) : "",
                                }
                            });

                            setSalesTeamData(dataList);
                        }
                    });
                    showLoador({ loador: false });
                }
            } else {
                showNotification({ msg: noInternetMsg, severity: "error" });
            }
        }
        fetchData();
    }, []);

    return (
        <>
            <Paper
                sx={{
                    p: 2,
                    borderRadius: 0,
                }}
                elevation={0}
            >

                <DynamicFormWithoutSave
                    showBackToList={true}
                    dynamicMasterData={{}}
                    showTitle={true}
                    screenTitle={"Encashed Details"}
                    fieldMeta={[]}
                    showSaveNextBtn={[]}
                    saveBtnText={"Search"}
                    showSaveBtnMain={false}
                />

                <div style={cardViewStyles.containerStyle}>

                    {salesTeamData.length !== 0 ? (
                        <>
                            {salesTeamData.map((record) => (
                                <div
                                    key={record.id}
                                    style={cardViewStyles.cardStyle}
                                    onMouseEnter={(e) => {
                                        e.currentTarget.style.transform = 'translateY(-4px)';
                                        e.currentTarget.style.boxShadow = '0 12px 24px rgba(0, 0, 0, 0.15)';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.currentTarget.style.transform = 'translateY(0)';
                                        e.currentTarget.style.boxShadow = '0 4px 6px rgba(0, 0, 0, 0.1)';
                                    }}
                                >
                                    <div style={cardViewStyles.headerSectionStyle}>
                                        <div style={cardViewStyles.headerGridStyle}>
                                            <div style={cardViewStyles.headerItemStyle}>
                                                <span style={cardViewStyles.labelStyle}>Sales Team Name:</span>
                                                <span style={cardViewStyles.valueStyle}>{record.salesTeamName}</span>
                                            </div>

                                            <div style={cardViewStyles.headerItemStyle}>
                                                <span style={cardViewStyles.labelStyle}>Designation:</span>
                                                <span style={cardViewStyles.valueStyle}>{record.designation}</span>
                                            </div>

                                            <div style={cardViewStyles.headerItemStyle}>
                                                <span style={cardViewStyles.labelStyle}>Year Name:</span>
                                                <span style={cardViewStyles.badgeStyle}>{record.leaveYearName}</span>
                                            </div>

                                            <div style={cardViewStyles.headerItemStyle}>
                                                <span style={cardViewStyles.labelStyle}>Record Insert Date:</span>
                                                <span style={cardViewStyles.valueStyle}>{record.insertDateTime}</span>
                                            </div>
                                        </div>
                                    </div>

                                    <div style={cardViewStyles.tableContainerStyle}>
                                        <table style={cardViewStyles.tableStyle}>
                                            <thead style={cardViewStyles.tableHeaderStyle}>
                                                <tr>
                                                    <th style={{
                                                        ...cardViewStyles.thStyle, width: '170px', textAlign: 'center',
                                                    }}>Sr. No</th>
                                                    <th style={{ ...cardViewStyles.thStyle, width: '500px' }}>Leave Type</th>
                                                    <th style={{
                                                        ...cardViewStyles.thStyle,
                                                        textAlign: 'left',
                                                        width: '205px',
                                                        padding: '12px 38px',
                                                    }}>Encashed Leaves</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {record.encashedLeaveDetails && record.encashedLeaveDetails.map((detail) => (
                                                    <tr key={detail.id}>
                                                        <td style={{ ...cardViewStyles.tdStyle, textAlign: 'center' }}>{detail.index}</td>
                                                        <td style={{ ...cardViewStyles.tdStyle, fontWeight: '500' }}>{detail.leaveTypeName}</td>
                                                        <td style={{
                                                            ...cardViewStyles.tdStyle,
                                                            textAlign: 'right',
                                                            fontWeight: '600',
                                                            color: '#059669',
                                                            padding: '12px 100px',
                                                        }}>
                                                            {detail.encashedLeaves}
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            ))}

                        </>
                    ) : (
                        (
                            <div style={cardViewStyles.noDataStyle}>
                                <div style={cardViewStyles.noDataTextStyle}>No Data Found</div>
                                <div style={cardViewStyles.noDataSubtextStyle}>There are no carry forward leave records to display</div>
                            </div>
                        )

                    )}



                </div>

            </Paper >
        </>
    );
}

const mapStateToProps = (state) => ({});
const mapDispatchToProps = {
    showNotification,
    showLoador,
};
export default compose(
    withRouter,
    connect(mapStateToProps, mapDispatchToProps)
)(EncashedLeaveView);